import { TileIndex } from "../../types";

export const TURN_LEVEL: TileIndex[][] = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 17, 28, 28, 28, 28, 28, 28, 0, 5, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 0, 0, 0, 0, 0, 0, 1, 0, 1, 23, 16, 23, 31, 23, 16, 21, 1],
  [1, 1, 0, 0, 0, 0, 0, 0, 1, 0, 1, 20, 16, 16, 16, 16, 16, 21, 1],
  [1, 1, 0, 0, 0, 0, 0, 0, 1, 0, 1, 20, 22, 16, 16, 16, 16, 21, 1],
  [1, 1, 0, 0, 0, 0, 0, 0, 1, 21, 1, 20, 22, 22, 22, 21, 22, 22, 1],
  [1, 1, 1, 16, 16, 1, 1, 1, 1, 0, 1, 1, 1, 1, 20, 21, 1, 1, 1],
  [1, 0, 0, 30, 0, 18, 0, 0, 0, 0, 0, 0, 0, 0, 20, 21, 0, 0, 1],
  [1, 0, 18, 0, 0, 0, 0, 0, 0, 19, 0, 30, 1, 1, 0, 0, 0, 0, 1],
  [1, 0, 0, 18, 0, 18, 0, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 0, 1, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 1, 10, 1],
  [1, 0, 1, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 1, 16, 1],
  [1, 28, 1, 1, 1, 1, 1, 1, 1, 9, 1, 1, 1, 1, 1, 20, 1, 16, 1],
  [1, 6, 1, 15, 2, 2, 2, 2, 2, 5, 2, 2, 2, 2, 1, 20, 22, 2, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
]
/* export const TURN_LEVEL: TileIndex[][] = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 0, 0, 0, 0, 16, 16, 0, 0, 0, 0, 31, 0, 0, 0, 16, 16, 0, 0, 0, 0, 1],
  [1, 0, 2, 2, 18, 16, 16, 0, 0, 0, 2, 2, 0, 0, 0, 16, 16, 0, 0, 0, 0, 1],
  [1, 0, 2, 2, 18, 16, 16, 0, 0, 0, 0, 0, 0, 0, 0, 16, 16, 2, 2, 2, 0, 1],
  [
    1, 0, 0, 0, 0, 16, 16, 21, 21, 21, 21, 21, 21, 21, 21, 16, 16, 2, 15, 2, 0,
    1,
  ],
  [
    1, 16, 16, 16, 16, 16, 23, 23, 21, 21, 21, 21, 21, 21, 22, 22, 16, 16, 16,
    16, 16, 1,
  ],
  [
    1, 16, 16, 16, 16, 16, 23, 23, 23, 21, 21, 21, 21, 22, 22, 22, 16, 16, 16,
    16, 16, 1,
  ],
  [
    1, 0, 18, 18, 0, 0, 23, 23, 23, 21, 21, 21, 21, 22, 22, 22, 0, 0, 0, 0, 0,
    1,
  ],
  [1, 0, 0, 0, 0, 0, 23, 23, 23, 12, 0, 0, 31, 22, 22, 22, 0, 0, 2, 31, 0, 1],
  [1, 0, 0, 0, 0, 0, 23, 23, 23, 20, 20, 20, 20, 22, 22, 22, 0, 0, 0, 0, 0, 1],
  [
    1, 16, 16, 16, 16, 16, 23, 23, 23, 20, 20, 20, 20, 22, 22, 22, 16, 16, 16,
    16, 16, 1,
  ],
  [
    1, 16, 16, 16, 16, 16, 23, 23, 20, 20, 20, 20, 20, 20, 22, 22, 16, 16, 16,
    16, 16, 1,
  ],
  [
    1, 0, 0, 0, 0, 16, 16, 20, 20, 20, 20, 20, 20, 20, 20, 16, 16, 0, 17, 0, 2,
    1,
  ],
  [1, 1, 1, 1, 0, 16, 16, 0, 0, 0, 0, 0, 0, 1, 0, 16, 16, 0, 0, 0, 2, 1],
  [1, 1, 1, 1, 0, 16, 16, 0, 0, 0, 0, 0, 0, 26, 0, 0, 13, 0, 27, 0, 2, 1],
  [1, 1, 1, 1, 25, 16, 16, 30, 0, 0, 31, 0, 0, 1, 0, 16, 16, 0, 0, 0, 2, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
];
 */